import { Control, FieldValues } from 'react-hook-form';

import { InputProps } from '../types';

import { CustomDataFieldComponent } from './getComponent';

type PropsType = {
  name: string;
  info?: string;
  inputProps: InputProps;
  type: string;
  control: Control<FieldValues>;
};

export const EditCustomDataFields = (props: PropsType) => {
  const { name, inputProps, type, control } = props;
  return (
    <div>
      <CustomDataFieldComponent
        type={type}
        control={control}
        inputProps={inputProps}
        label={name}
      />
    </div>
  );
};
